// Enhanced Footer.jsx with comprehensive legal disclaimers

import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  List, 
  ListItem, 
  ListItemText, 
  Divider,
  Link,
  Alert,
  Paper
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Warning, School, Gavel, Shield } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box sx={{ 
      backgroundColor: '#15171a', 
      color: 'white', 
      py: 6,
      background: 'linear-gradient(135deg, #15171a 0%, #1e2126 100%)'
    }}>
      <Container maxWidth="lg">
        {/* Main Footer Content */}
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: '#5980a6' }}>
              XAUPilot
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 2 }}>
              Trading Platform
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>
              Gold trading and market analysis. 
              Not a registered investment advisor.
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Trading
            </Typography>
            <List dense disablePadding>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Signals
                    </Link>
                  }
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Market Analysis
                    </Link>
                  }
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Performance Metrics
                    </Link>
                  }
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Pricing
                    </Link>
                  }
                />
              </ListItem>
            </List>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Gavel sx={{ fontSize: '1.2rem', mr: 1, color: '#5980a6' }} />
              <Typography variant="subtitle1" fontWeight={600}>
                Legal & Compliance
              </Typography>
            </Box>
            <List dense disablePadding>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/terms" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Terms of Service
                    </Link>
                  }
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/privacy" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Privacy Policy
                    </Link>
                  }
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      component={RouterLink} 
                      to="/risk-disclosure" 
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Risk Disclosure
                    </Link>
                  }
                />
              </ListItem>
            </List>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Shield sx={{ fontSize: '1.2rem', mr: 1, color: '#5980a6' }} />
              <Typography variant="subtitle1" fontWeight={600}>
                Support
              </Typography>
            </Box>
            <List dense disablePadding>
              <ListItem disablePadding>
                <ListItemText 
                  primary={
                    <Link 
                      href="mailto:support@xaupilot.com"
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        fontSize: '0.875rem',
                        textDecoration: 'none',
                        '&:hover': { 
                          color: '#5980a6',
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      support@xaupilot.com
                    </Link>
                  }
                />
              </ListItem>
            </List>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Regulatory Info
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block', mb: 1 }}>
              Not a registered investment advisor
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block', mb: 1 }}>
              Educational platform only
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block', mb: 1 }}>
              No financial advice provided
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block' }}>
              Independent research required
            </Typography>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        {/* Legal Compliance Section */}
        <Paper 
          elevation={1}
          sx={{
            background: 'rgba(255, 255, 255, 0.05)',
            p: 3,
            borderRadius: 2,
            mb: 3,
            border: '1px solid rgba(191, 155, 48, 0.2)'
          }}
        >
          <Typography variant="h6" sx={{ color: '#5980a6', mb: 2, fontWeight: 600 }}>
            Legal Compliance & Educational Purpose Statement
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 2 }}>
                <strong>Educational Service:</strong> XAUPilot provides educational content about trading and financial markets. 
                All signals, analysis, and commentary are for educational and informational purposes only.
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                <strong>Not Investment Advice:</strong> Nothing on this platform constitutes investment advice, 
                financial guidance, or trading recommendations. Users must conduct independent research.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 2 }}>
                <strong>Risk Acknowledgment:</strong> Trading and investing involve substantial risk of loss. 
                Past performance does not guarantee future results. Educational content may not be suitable for all users.
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                <strong>Professional Advice:</strong> Consult qualified, licensed financial advisors before making 
                any investment decisions. XAUPilot is not a registered investment advisor or broker-dealer.
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Final Footer */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.5)', mb: 2 }}>
            © {new Date().getFullYear()} XAUPilot. All rights reserved.
          </Typography>
          
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '0.75rem', mb: 1 }}>
            <strong style={{ color: '#cf6f61' }}>⚠️ Final Risk Warning:</strong> Trading involves substantial risk of loss and is not suitable for all investors. 
            Educational content only - not financial advice. Read our{' '}
            <Link 
              component={RouterLink} 
              to="/risk-disclosure"
              sx={{ 
                color: '#5980a6',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Risk Disclosure
            </Link>
            {' '}and{' '}
            <Link 
              component={RouterLink} 
              to="/terms"
              sx={{ 
                color: '#5980a6',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Terms of Service
            </Link>
            {' '}before using our educational platform.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
